export default __webpack_public_path__ + "static/media/cooking_2020_OV_seemore_SD-ZP2000EU-K_03_201218.5f66ad2b.jpg";